/**
 * @description 快捷监听键盘事件
 * 暴露到window方便调用，该事件全局监听，使用时注意在destory取消事件监听。
 * 快捷使用：
 * 事件监听：window.$shortcut.add('ctrl+c', callback);
 * 取消事件监听：window.$shortcut.remove('ctrl+c');
 */

window.$shortcut = {
  // 用于存储快捷键
  shortcuts_store: {},

  // 特殊按键及其keycode
  special_keys: {
    esc: 27,
    escape: 27,
    tab: 9,
    space: 32,
    return: 13,
    enter: 13,
    backspace: 8,

    scrolllock: 145,
    scroll_lock: 145,
    scroll: 145,
    capslock: 20,
    caps_lock: 20,
    caps: 20,
    numlock: 144,
    num_lock: 144,
    num: 144,

    pause: 19,
    break: 19,

    insert: 45,
    home: 36,
    delete: 46,
    end: 35,

    pageup: 33,
    page_up: 33,
    pu: 33,

    pagedown: 34,
    page_down: 34,
    pd: 34,

    left: 37,
    up: 38,
    right: 39,
    down: 40,

    f1: 112,
    f2: 113,
    f3: 114,
    f4: 115,
    f5: 116,
    f6: 117,
    f7: 118,
    f8: 119,
    f9: 120,
    f10: 121,
    f11: 122,
    f12: 123
  },

  // shift + * 组合键对应一些特殊字符，会出现监听无效的bug
  shift_combine_keys: {
    '`': '~',
    '1': '!',
    '2': '@',
    '3': '#',
    '4': '$',
    '5': '%',
    '6': '^',
    '7': '&',
    '8': '*',
    '9': '(',
    '0': ')',
    '-': '_',
    '=': '+',
    ';': ':',
    "'": '"',
    ',': '<',
    '.': '>',
    '/': '?',
    '\\': '|'
  },

  // 增加快捷键监听
  add: function (shortcutStr, callback, option) {
    const that = this
    let ele // 监听元素，默认document
    // 默认配置
    const defaultOptions = {
      type: 'keydown',
      preventDefault: false,
      disableInInput: false, // 在可输入控件下是否禁用快捷键
      target: document, // 目前支持 dom 或者是 id
      keycode: false,
      disabledModifiers: false
    }
    shortcutStr = shortcutStr.toLowerCase()

    // 处理默认配置项
    if (!option) {
      option = defaultOptions
    } else {
      for (let dfo in defaultOptions) {
        if (typeof option[dfo] === 'undefined') option[dfo] = defaultOptions[dfo]
      }
    }

    ele = option.target
    if (typeof option.target === 'string') ele = document.getElementById(option.target)

    // 按下按钮触发回调
    const keypressCallback = function (e) {
      e = e || window.event
      let code
      const keys = shortcutStr.split('+')
      // 记录被按下的次数
      let keyPressNum = 0

      if (option['disableInInput']) {
        // 在可输入控件Input和textarea下禁用快捷键
        let element
        if (e.target) element = e.target
        else if (e.srcElement) element = e.srcElement
        if (element.nodeType === 3) element = element.parentNode

        if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') return
      }

      // 识别被按下的键
      if (e.keyCode) code = e.keyCode
      else if (e.which) code = e.which
      let character = String.fromCharCode(code).toLowerCase()

      if (code === 188) character = ','
      if (code === 190) character = '.'
      if (code === 191) character = '/'

      // 组合按键修饰符
      const modifiers = {
        shift: { wanted: false, pressed: false },
        ctrl: { wanted: false, pressed: false },
        alt: { wanted: false, pressed: false },
        meta: { wanted: false, pressed: false } // Meta只针对mac，即为mac的command
      }

      if (e.ctrlKey) modifiers.ctrl.pressed = true
      if (e.shiftKey) modifiers.shift.pressed = true
      if (e.altKey) modifiers.alt.pressed = true
      if (e.metaKey) modifiers.meta.pressed = true

      // 遍历所有key
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i]
        // 修饰符
        if (k === 'ctrl' || k === 'control') {
          keyPressNum++
          if (!option.disabledModifiers) modifiers.ctrl.wanted = true
        } else if (k === 'shift') {
          keyPressNum++
          if (!option.disabledModifiers) modifiers.shift.wanted = true
        } else if (k === 'alt') {
          keyPressNum++
          if (!option.disabledModifiers) modifiers.alt.wanted = true
        } else if (k === 'meta' || k === 'command') {
          keyPressNum++
          if (!option.disabledModifiers) modifiers.meta.wanted = true
        } else if (k.length > 1) {
          // 特殊按键
          if (that.special_keys[k] === code) keyPressNum++
        } else if (option['keycode']) {
          if (option['keycode'] === code) keyPressNum++
        } else {
          // 未匹配特殊按键
          if (character === k) keyPressNum++
          else {
            if (that.shift_combine_keys[character] && e.shiftKey) {
              // 处理shift + * 键引起的问题
              character = that.shift_combine_keys[character]
              if (character === k) keyPressNum++
            }
          }
        }
      }

      // 当按键次数及修饰符符合时，响应键盘按键
      if (
        keyPressNum === keys.length &&
        modifiers.ctrl.pressed === modifiers.ctrl.wanted &&
        modifiers.shift.pressed === modifiers.shift.wanted &&
        modifiers.alt.pressed === modifiers.alt.wanted &&
        modifiers.meta.pressed === modifiers.meta.wanted
      ) {
        callback(e)

        if (option['preventDefault']) {
          // 阻止默认事件
          e.cancelBubble = true
          e.returnValue = false
          if (e.stopPropagation) {
            e.stopPropagation()
            e.preventDefault()
          }
          return false
        }
      }
    }

    that.shortcuts_store[shortcutStr + '-' + option.type] = {
      callback: keypressCallback,
      target: ele,
      event: option['type']
    }

    // 绑定监听事件
    if (ele.addEventListener) ele.addEventListener(option['type'], keypressCallback, false)
    else if (ele.attachEvent) ele.attachEvent('on' + option['type'], keypressCallback)
    else ele['on' + option['type']] = keypressCallback
  },

  // 移除监听事件
  remove: function (shortcutStr, eventType = 'keydown') {
    shortcutStr = shortcutStr.toLowerCase()
    const binding = this.shortcuts_store[shortcutStr + '-' + eventType]
    delete this.shortcuts_store[shortcutStr]
    if (!binding) return
    const type = binding['event']
    const ele = binding['target']
    const callback = binding['callback']

    if (ele.detachEvent) ele.detachEvent('on' + type, callback)
    else if (ele.removeEventListener) {
      ele.removeEventListener(type, callback, false)
    } else ele['on' + type] = false
  }
}
